<section class="col-xs-12 cart_titlesection cartsectionuk" *ngIf="startcart | async  as item">
    <div class="col-xs-12 col-md-8 mycartsection">
        <div class="cart_header">{{item.headline}}</div>
        <div class="cart_subheader"></div>
    </div>
    <div *ngIf="enablePage.showLocationPage || enablePage.showProductPage || enablePage.showReviewPage || enablePage.showSorryPage || enablePage.showSaveThankYouPage || enablePage.showConfirmThankYouPage || enablePage.showinseasonConfirmThankYouPage || enablePage.showAmendProductPage" class="cart_dateheader" [innerHtml]="item.content" ></div>
</section>
